import getInstanceAxios from '../Request';

const baseDomain = process.env.REACT_APP_CUSTOMER_INSIGHT;
const baseURL = `${baseDomain}/`;

export default getInstanceAxios(baseURL);
